/**
 * Formats partagés des workspaces Publication (Location / Vente).
 */

/** "2026-09-16" → "16/09/26". Tolère une valeur non ISO (renvoyée telle quelle). */
export function formatShortDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${d.slice(0, 2)}/${m}/${y.slice(-2)}`;
}

/** "1280000" → "1 280 000 €" (fr-BE). "" si absent / non numérique. */
export function formatEuro(v?: string | null): string {
  if (!v || !v.trim()) return "";
  const n = parseFloat(v);
  if (Number.isNaN(n)) return "";
  return `${n.toLocaleString("fr-BE")} €`;
}
